/**
 *
 * @ngdoc service
 * @name starter.service:cheetah
 * @description
 * The access point to searching for results/clustering/recommendation
 * This service creates the request and parese the response in to the foam format which will be used to present the results
 */

'use strict';

import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
import {getInstitutionCode, getVid, getDisableCacheParameters, getResultsBulkSize, getNewspapersSearchEnabled, getRefEntryActive, getDefaultScope, getTab} from '../appConfig/appConfigForward';


import {Injectable, Inject } from 'ng-metadata/core';
import {SharedSessionStorage} from '../infra/sharedSessionStorage.service';
import {PersonalizeResultsButtonService} from './personalization/personalizationButton/personalizeResultsButton.service';
import {NewspapersService} from '../newspapers/newspapers.service';
import {PreFiltersService} from './preFilters/preFilters.service';
import {ResultUtil} from "../nddUtils/resultUtil.service";
import { SearchBarService } from './searchBar/searchBar.service';
import { StorageUtil } from '../infra/storageUtil.service';
import {JwtUtilService} from '../security/jwtUtil.service';
import {STATE_NAMES} from "../primoExplore/primoExploreStates.module";

const forEach= require('lodash/forEach');

@Injectable()
export class Cheetah{
    private inst = getInstitutionCode();
    private NEWSPAPERS_SEARCH_ENABLED: boolean = getNewspapersSearchEnabled();
    private refEntryActive: boolean = getRefEntryActive();
    private readonly searchRestUrl: string;
    private getFacetsRestUrl: string;
    private authorityRelatedRestUrl = this.restBaseURLs.authoritySearchBibURL;
    private vid = getVid();
    private disableCache:boolean = getDisableCacheParameters();
    private dataToBeSent:Object;
    private PAGE_SIZE;
    private searchCancelDeferredObject: ng.IDeferred<any>;
    private searchInProgress = false;
    private _firstAuthRequest: boolean = true;
    private prevPatronsDefaultSort;

    constructor(
        @Inject('$http') private $http: angular.IHttpService,
        @Inject('restBaseURLs') private restBaseURLs,
        private configurationUtil: ConfigurationUtil,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        private sharedSessionStorage: SharedSessionStorage,
        private personalizeResultsButtonService: PersonalizeResultsButtonService,
        private newspapersService : NewspapersService,
        @Inject('$state') private $state: ng.ui.IStateService,
        @Inject('$location') private $location: ng.ILocationService,
        private preFiltersService : PreFiltersService,
        private resultUtil: ResultUtil,
        private storageUtil: StorageUtil,
        private searchBarService: SearchBarService,
        private jwtUtilService: JwtUtilService,
        @Inject('$q') private $q: ng.IQService) {
        this.searchRestUrl = restBaseURLs.pnxBaseURL;
        this.getFacetsRestUrl = this.configurationUtil.isSuprima() ? restBaseURLs.getFacetsBaseURL : this.searchRestUrl;
    }

    get searchData(){
        return this.dataToBeSent;
    }

    get pageSize() {
        return this.resultUtil.updatedBulkSize;
    }

    public get firstAuthRequest(): boolean {
        return this._firstAuthRequest;
    }
    
    public set firstAuthRequest(value: boolean) {
        this._firstAuthRequest = value;
    }
    
    /**
     * @ngdoc function
     * @name performSearch
     * @methodOf starter.service:cheetah
     * @description This function initializes the search parameters accurding the the API
     *
     *
     */
    public performSearch(args, additionalData, fromRegularSearch, isFacetSearch = false) {
        //fromIndex,bulkSize,query,facets, scope, sortBy, options
        /* ';' caused problems in server side, need to replace it in ',' only in simple search,
         in advanced search this character was removed earlier*/
        if (isFacetSearch && this.searchInProgress){
            return this.$q.reject('there is a newer search than the one we are trying to get facets for so this facets request is irrelevant');
        }
        let myQuery = args.query;

        if (!args.mode || args.mode !== 'advanced') {
            myQuery = this.preFiltersService.removePreFilter(myQuery,true,' ');
        }

        let personalizationArr = this.sharedSessionStorage.getItem('personalization');
        let personalization = '';
        if ((this.personalizeResultsButtonService.enable) && (personalizationArr !== null) && (personalizationArr.length > 0)) {
            personalization = personalizationArr.split(',').join(';');
        }

        let facets = args.facets || [];
        let scope = this.$state.params['mode']=== 'browse'? "browse_search":args.scope
        //console.log(JSON.stringify(args));
        let dataToBeSent;
        if (isFacetSearch && args.facetsCacheKey) {
            dataToBeSent = {
                facetsCacheKey : args.facetsCacheKey,
                vid: this.vid
            }
        }
        else {
            dataToBeSent = {
                offset: 0,
                inst: args.overrideViewInstitution || this.inst,
                limit: args.bulkSize,
                vid : this.vid,
                scope: scope,
                tab: args.tab || (this.configurationUtil.isSuprima() ? getTab(scope) : 'default_tab'),
                q:  myQuery,
                journals: args.journals,
                databases: args.databases,
                featuredNewspapersIssnList: args.featuredNewspapersIssnList,
                fromDate: args.fromDate,
                qInclude : facets.filter(f => (f.type === 'include' || f.type === 'exact') && f.isMultiFacet !== true)
                    .map(this.facetToString).join('|,|'),
                qExclude : facets.filter(f => f.type === 'exclude' && f.isMultiFacet !== true)
                    .map(this.facetToString).join('|,|'),
                lang: this.$translate.use(),
                explain: args.explain,
                otbRanking: args.otbRanking,
                sort: args.sortby,
                searchInFulltextUserSelection : args.searchInFulltextUserSelection,
                pcAvailability : args.pcAvailability,
                rtaLinks : true,
                disableCache : this.disableCache,
                getMore: args.getMore ? args.getMore : 0,
                browseParams: args.browseParams,
                came_from : this.$state.params['came_from'],
                skipDelivery : args.skipDelivery || 'N',
                isCDSearch : args.isCDSearch || false,
                mode : this.$state.params['mode'],
                newspapersActive : this.NEWSPAPERS_SEARCH_ENABLED,
                refEntryActive:this.refEntryActive,
                searchCDI: args.searchCDI,
                savedSearchId: args.savedSearchId,
                oSSKey: args.oSSKey,
                rapido: args.rapido,
                newspapersSearch: false,
                blendFacetsSeparately: args['blendFacetsSeparately'],
                isRelatedItems: args.isRelatedItems,
                organization: args.organization,
                citationTrailFilterByAvailability: args.citationTrailFilterByAvailability,
                acTriggered: this.searchBarService.acTriggered,
                originatingSystem: args.originatingSystem,
                originatingSystemId: args.originatingSystemId,
                isRAsearch: args.isRAsearch
            };
            let multiFacetsIndexes = [];
            let multiFacetsArr = [];
            forEach(facets, (f)=> {
                if ((f.isMultiFacet === true) && (multiFacetsIndexes.indexOf(f.multiFacetGroupId) == -1)) {
                    multiFacetsIndexes.push(f.multiFacetGroupId);
                }
            });
            if (multiFacetsIndexes.length) {
                forEach(multiFacetsIndexes, (groupId)=> {
                    let multiFacets = [];
                    multiFacets = facets.filter(f => f.isMultiFacet === true && f.multiFacetGroupId === groupId).map(this.facetToString).join('|,|');
                    if (multiFacets.length) {
                        multiFacetsArr.push(multiFacets);
                    }
                    multiFacets = [];
                });
                if (multiFacetsArr.length) {
                    dataToBeSent.multiFacets = multiFacetsArr;
                }
            }

            if (this.newspapersService.isNewspapersSearch()) {
                dataToBeSent.newspapersSearch = true;
                dataToBeSent.tab = undefined;
            }

            if (this.isPatronsDefaultSortEnabled() && this.usePatronsDefaultSort()) {
                if(isFacetSearch && !this.jwtUtilService.isGuest() && (!dataToBeSent.sort || this.prevPatronsDefaultSort  === 'rank')){
                    dataToBeSent.sort = 'rank';
                }else{
                    dataToBeSent.sort = this.storageUtil.sessionStorage.getItem('patronsDefaultSort') ? this.storageUtil.sessionStorage.getItem('patronsDefaultSort') : dataToBeSent.sort;//init sort by from DB
                }
            }
            this.prevPatronsDefaultSort = dataToBeSent.sort;

            this.dataToBeSent = dataToBeSent;
            if (args.offset) {
                dataToBeSent.offset = args.offset - (args.offset % this.pageSize); //we round down to offset of beginning of nearest page
            }
            if (personalization) {
                let recentness = this.sharedSessionStorage.getItem('recentness')==='true' ? 1 : 0;
                dataToBeSent.personalization = '1,' + recentness + ',' + personalization;
            }

            let data = this.searchRestUrl  +
                "&offset=" + dataToBeSent.offset + "&inst=" + dataToBeSent.inst + "&limit=" + dataToBeSent.limit +
                "&vid=" + dataToBeSent.vid + "&scope=" + dataToBeSent.scope + "&tab=" + dataToBeSent.tab +
                "&q=" + dataToBeSent.q + "&qInclude=" + dataToBeSent.qInclude + "&qExclude=" + dataToBeSent.qExclude +
                "&lang=" + dataToBeSent.lang + "&sort=" + dataToBeSent.sort + "&pcAvailability=" + dataToBeSent.pcAvailability + "&searchInFulltext=" + dataToBeSent.searchInFulltextUserSelection+
                "&acTriggered=" +dataToBeSent.acTriggered + "&rtaLinks=" + dataToBeSent.rtaLinks + "&disableCache=" + dataToBeSent.disableCache + "&isRelatedItems" + dataToBeSent.isRelatedItems +
                "&isCDSearch=" + dataToBeSent.isCDSearch + "&isRAsearch" +dataToBeSent.isRAsearch;

            if(args['otbRanking']){
                data += "&otbRanking=" + dataToBeSent.otbRanking;
            }

            if(args['noConVoc']) {
                data+="&conVoc=false";
                dataToBeSent['conVoc']="false";
            }

            this.sharedSessionStorage.setItem('suprimaSearchApiurl', data);


            console.log('Search for'+
                ' query: '+dataToBeSent.q+
                ' scope: '+dataToBeSent.scope+
                ' facets: '+dataToBeSent.qInclude+
                ' sorted by:'+ dataToBeSent.sort +
                ' is related items:' + dataToBeSent.isRelatedItems);
        }

        if (!isFacetSearch){ //if this is the second call during blended search don't update the timestamp since this call is only for displaying facets
            window.appPerformance.timeStamps['search api send']= Date.now();
        }

        let restUrl = isFacetSearch? this.getFacetsRestUrl : this.searchRestUrl;
        restUrl = dataToBeSent.mode =="authority" ? this.authorityRelatedRestUrl: restUrl;

		if (this.firstAuthRequest) {
            if (fromRegularSearch){
            	        if(this.searchCancelDeferredObject && !isFacetSearch){
            	            this.searchCancelDeferredObject.resolve('search canceled by newer one'); //this will "throw away" any ongoing search requests. If we have a few searches in parallel we only want to use the latest one
            	        }
            	        this.searchCancelDeferredObject = this.$q.defer();
            	        if (!isFacetSearch){
                            this.searchInProgress = true;
                        }
            	        return this.$http.get(restUrl, {
            	            params:dataToBeSent,
                            timeout: this.searchCancelDeferredObject.promise
            	        }).finally(() => {
                            if (!isFacetSearch){
                                this.searchInProgress = false;
                            }
                            if(dataToBeSent.mode =="authority"){
                                this.firstAuthRequest = false;
                            }
                        });
                    } else{
            	        return this.$http.get(restUrl, {
            	            params:dataToBeSent
            	        });
                    }
        }
        else return Promise.resolve(false);
    }

    public isScopeBlended(scope){
        let scopeContext = window.appConfig['scopes-context-map'][scope];
        return (scopeContext === 'B');
    }



    private facetToString(facet) {
        /* private members */
        let facetType = facet.isMultiFacet && facet.type ? facet.type : 'exact';
        let facetValue= {
            'range': (facet) => {
                return 'facet_' + facet.name + ',' + facetType + ',' + '[' + facet.value.replace('|,|', ' TO ') + ']';
            },
            'exact' : (facet) => {
                return 'facet_' + facet.name + ',' + facetType + ',' + facet.value;
            },
            'default' : (facet) => {
                return 'facet_' + facet.name + ',' + facetType + ',' + facet.value;
            }
        };
        let displayedType = facet.displayedType;

        if (!facet.displayedType || !facetValue[facet.displayedType]) {
            facet.displayedType = 'default';
        }

        return facetValue[displayedType](facet);
    }


    performFacetSearch(args, additionalData,) {
        if (!this.configurationUtil.isSuprima()){
            throw new Error("facet search is only supported by PrimoVE");
        }
        return this.performSearch(args, additionalData, true, true);
    }
    
    public isPatronsDefaultSortEnabled() {
        return !this.configurationUtil.isSuprima() || this.configurationUtil.getFeatureFlag('patrons_default_sort');
    }
    
    public usePatronsDefaultSort() {
        return this.storageUtil.sessionStorage.getItem('patronsDefaultSort') && !this.$state.params['sortby']
            && this.$state.current.name === STATE_NAMES.SEARCH; // use only for simple/advanced search
    }
}










// WEBPACK FOOTER //
// ./src/main/webapp/components/search/cheetah.service.ts